import { render, staticRenderFns } from "./LegoViewTablero.vue?vue&type=template&id=b0188be2&scoped=true"
import script from "./LegoViewTablero.vue?vue&type=script&lang=js"
export * from "./LegoViewTablero.vue?vue&type=script&lang=js"
import style0 from "./LegoViewTablero.vue?vue&type=style&index=0&id=b0188be2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0188be2",
  null
  
)

export default component.exports